module.exports = {
  "country": "IE",
  "artist": "Bambie Thug",
  "song": "Doomsday Blue",
  "year": "2024",
  "place": "6",
  "spotify": "7qiEoVlFjb3KaytT2zgK1g"
};